import { Controller } from "stimulus"
import axios from "axios";

export default class extends Controller {
  static targets = ["checkbox", "status"]

  updateMarketing(event) {
    const tokenContainer = document.querySelector('meta[name="csrf-token"]')
    let requestConfig = {};
    if (tokenContainer) {
      requestConfig = { headers: { 'X-CSRF-Token': tokenContainer.content } }
    }

    const requestData = {
      marketing_accepted: this.checkboxTarget.checked
    }

    axios.post('/ajustes', requestData, requestConfig)
      .then((response) => {
        this._updateStatus("Preferencia guardada correctamente");
      })
      .catch((error) => {
        this._updateStatus("Error al guardar tu preferencia");
      })
  }

  _updateStatus(message) {
    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML = message;
      this.statusTarget.classList.remove("hidden");
      setTimeout(() => {
        this.statusTarget.classList.add("hidden");
      }, 3000);
    }
  }
}
